export const APPLICATION_STAGES = {
    ApplicationPending: 'Application Pending',
    ApplicationSubmitted: 'Application Submitted',
    CreditReportPending: 'Credit Report Pending',
    ApplicationCreated: 'Application Created',
    BorrowerDetailsPending: 'Borrower Details Pending',
    BorrowerDocumentPending: 'Borrower Document Pending',
    BorrowerBankPending: 'Borrower Bank Pending',
    CoBorrowerDetailsPending: 'Co-Borrower Details Pending',
    NomineeDetailsPending: 'Nominee Details Pending',
    ResidenceDetailsPending: 'Residence Details Pending',
    BusinessDetailsPending: 'Business Details Pending',
    BusinessDocumentPending: 'Business Document Pending',
    BM_FI: 'BM_FI',
    BMRecommendation: "Bm Recommendation Pending",
    BCMVerification: 'BCM Verification Pending',
    BCMRecommendation: "Bcm Recommendation Pending",
    SalesData: "Sales Data",
    PurchasePending: "Purchase Pending",
    StockDetails: "Stock Details",
    OtherAssets: "Other Assets",
    Reference: "Reference Pending",
    ExpenseReport: "Expense Report",
    Assets: "Assets",
    BCMRecommendationsBusiness: "BCM Recommendations-Business Pending",
    SupplierPending: "Supplier Pending",
    BorrowerVerification: 'TVR Borrower Verification Pending',
    BusinessReferenceVerification: 'TVR Business Reference Verification Pending',
    InformalReferenceVerification: 'TVR Informal Reference Verification Pending',
    Sanctioned: "Sanction Pending",
    Disbursal: "Disbursal Pending",
    eSignRequested: "eSign Requested",
    eSignCompleted: "eSign Completed",
    BureauReject: 'Bureau Reject',
    ManualReject: 'Manual Rejected',
    RejectViaAdmin: 'Reject Via Admin',
    RejectViaBm: 'Reject Via BM',
    RejectViaBcm: 'Reject Via BCM',
    RejectViaRo: 'Reject Via RO',
    RejectViaSanction: 'Reject Via Sanction',
    RejectViaAccount: 'Reject Via Account',
    RejectViaOther: 'Reject Via Other',
}

export const TVR_APPLICATION_STAGES = {
    BorrowerVerification: 'TVR Borrower Verification Pending',
    BusinessReferenceVerification: 'TVR Business Reference Verification Pending',
    InformalReferenceVerification: 'TVR Informal Reference Verification Pending',
}

export const SUPPLIER_KYC_STATUS = {
    Pending: 'Pending',
    Verified: 'Verified', 
    Rejected: 'Rejected'
}

export const SUPPLIER_TYPES = {
    "Goods Supplier": 'Goods Supplier',
    "Service Provider": 'Service Provider',
}

export const TRANCHE_STATUS= {
    Closed: 'Closed',
    Approved: 'Approved',
    Rejected: 'Rejected',
    'Verification Pending': 'Verification Pending',
    'Tranche Initiated': 'Tranche Initiated',
    'Disbursal Pending': 'Disbursal Pending',
    'Pending': 'Pending'
}